import type { CompanionPanelAskNotice } from '@/hooks/actions/use-companion-panel-ask';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/** Written out in full so the i18n orphan check can see every key. */
const NOTICE_KEYS: Record<CompanionPanelAskNotice['kind'], string> = {
  in_progress: 'companion.conversation.notice.in_progress',
  plan: 'companion.conversation.notice.plan',
  error: 'companion.conversation.notice.error',
};

/**
 * Why the last question did not start, just above the composer that holds it
 * again. Announced by the live region the composer keeps mounted around it.
 */
export const CompanionPanelNotice = ({ kind }: { kind: CompanionPanelAskNotice['kind'] }) => {
  const { t } = useTranslation();

  return (
    <Box
      px="3"
      py="2.5"
      borderRadius="lg"
      bg="agent.subtle"
      textStyle="agent.text"
      color="agent.fgBody"
    >
      {t(NOTICE_KEYS[kind])}
    </Box>
  );
};
